// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/arrow-left-end-on-rectangle.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/solid/arrow-left-end-on-rectangle'

import { Icon, type IconComponentProps } from '../icon'

export const ArrowLeftEndOnRectangleIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
